import { render, staticRenderFns } from "./Storeabout.vue?vue&type=template&id=0e3c3a72&scoped=true"
import script from "./Storeabout.vue?vue&type=script&lang=js"
export * from "./Storeabout.vue?vue&type=script&lang=js"
import style0 from "./Storeabout.vue?vue&type=style&index=0&id=0e3c3a72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3c3a72",
  null
  
)

export default component.exports